import AdaptationsBulkModal from "./AdaptationsBulkModal";

export default AdaptationsBulkModal;
